import ArrowDownGlyph from 'ui/src/icons/ArrowDownGlyph';
import ArrowUpGlyph from 'ui/src/icons/ArrowUpGlyph';
import HamburgerMenuIcon from 'ui/src/icons/HamburgerMenuIcon';
import CloseIcon from 'ui/src/icons/CloseIcon';

import { type IIconsProps } from 'ui/src/components/Icon';

/**
 * MobileHeader Site Theme Classes
 */

const mobileHeaderIconToggleClasses = 'hidden';
const mobileHeaderIconOpenClasses = '';
const mobileHeaderIconCloseClasses = '';

const mobileMenuThemeClasses = 'hidden';

const mobileMenuNavClasses = '';

const mobileMenuNavListItemClasses = '';
const mobileMenuNavListItemActiveClasses = '';

const mobileMenuNavListItemNameClasses = '';

const mobileMenuSectionTitleClasses = '';
const mobileMenuSectionDividerClasses = '';

/**
 * MobileHeader Site Theme Icon Props
 */

const mobileMenuDropdownIconProps: IIconsProps = {
  bg: false,
  size: 'Glyph',
  options: {
    viewBox: '0 0 8 8',
    width: '6',
    height: '4',
    className: 'fill-neutrals-800',
  },
};

/**
 * MobileHeader Site Theme
 */

const mobileHeaderBlogTheme = {
  mobileHeaderIconToggleClasses,
  mobileHeaderIconOpenClasses,
  mobileHeaderIconCloseClasses,
  mobileMenuThemeClasses,
  mobileMenuNavClasses,
  mobileMenuNavListItemClasses,
  mobileMenuNavListItemActiveClasses,
  mobileMenuNavListItemNameClasses,
  mobileMenuDropdownIconProps,
  mobileMenuSectionTitleClasses,
  mobileMenuSectionDividerClasses,

  ExpandMoreIcon: ArrowDownGlyph,
  ExpandLessIcon: ArrowUpGlyph,
  HamburgerMenuIcon,
  CloseIcon,
};

export default mobileHeaderBlogTheme;
